// external imports
import React from 'react';
import PropTypes from 'prop-types';
import { useT } from 'client/i18n/hooks/useT';
// local imports
import FileInput from './components/FileInput';

class FilePickerClass extends React.Component {
  _validate = file => {
    const {
      onError,
      onChange,
      maxSize,
      maxSizeLabel,
      extensions,
      t,
    } = this.props;
    // make sure a file was provided in the first place
    if (!file) {
      onError(
        t(
          'FilePicker.FailedToUploadErrorMessage',
          'Failed to upload a file.',
          'Failed to upload file error message'
        )
      );
      return;
    }

    // if we care about file extensions
    if (extensions) {
      const uploadedFileExt = file.name.split('.').pop().toLowerCase();
      const isValidFileExt = extensions
        .map(ext => ext.toLowerCase())
        .includes(uploadedFileExt);

      if (!isValidFileExt) {
        onError(
          t(
            'FilePicker.FileExtensionErrorMessage',
            'Must upload a file of type: {extensions}',
            'Upload file extension error',
            {
              extensions: extensions.join(
                t(
                  'FilePicker.FileExtensionsSeparator',
                  ' or ',
                  'File extensions list separator'
                )
              ),
            }
          )
        );
        return;
      }
    }

    if (file.size > maxSize) {
      onError(
        t(
          'FilePicker.MaxSizeErrorMessage',
          `File size must be less than {maxSizeLabel} MB.`,
          'Upload max file size error message',
          {
            maxSizeLabel,
          }
        )
      );
      return;
    }

    // return native file object
    onChange(file);
  };

  render() {
    const {
      children,
      style,
      acceptedTypes,
      inputId,
      className,
      t,
    } = this.props;

    return (
      <FileInput
        onChange={this._validate}
        style={style}
        className={className}
        acceptedTypes={acceptedTypes}
        inputId={inputId}
        t={t}
      >
        {children}
      </FileInput>
    );
  }
}

FilePicker.defaultProps = {
  acceptedTypes: ['*'],
  maxSize: 100000000000000000,
};

FilePicker.propTypes = {
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  // max file size in MB
  maxSize: PropTypes.number,
  // file extension
  extensions: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.objectOf(PropTypes.any),
  inputId: PropTypes.string,
  className: PropTypes.string,
};

export default function FilePicker(props) {
  const t = useT();
  return <FilePickerClass {...props} t={t} />;
}
